'use client';

import { slugify } from '@/services/string';
import {
  BlocksRenderer,
  type BlocksContent
} from '@strapi/blocks-react-renderer';
import React from 'react';

type BlockRendererClientProps = {
  readonly content: BlocksContent;
};

const BlockRendererClient = ({ content }: BlockRendererClientProps) => {
  const customBlocks = {
    link: ({ children, url }: { children?: React.ReactNode; url: string }) => (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
    heading: ({
      children,
      level
    }: {
      children?: React.ReactNode;
      level: number;
    }) => {
      if (!children) return null;

      const childArray = Array.isArray(children) ? children : [children];
      const childNode = childArray[0];

      const textContent = childNode?.props?.text;

      const slugId = slugify(textContent || '');

      const headerTagMap = {
        h1: <h1 id={slugId}>{children}</h1>,
        h2: <h2 id={slugId}>{children}</h2>,
        h3: <h3 id={slugId}>{children}</h3>,
        h4: <h4 id={slugId}>{children}</h4>,
        h5: <h5 id={slugId}>{children}</h5>,
        h6: <h6 id={slugId}>{children}</h6>
      };

      return headerTagMap[`h${level}` as keyof typeof headerTagMap];
    }
  };

  if (!content) return null;
  return <BlocksRenderer content={content} blocks={customBlocks} />;
};

export default BlockRendererClient;
